<script>
import {mapState} from "vuex";
import planCommon from './mixin';
import {filter, get, orderBy} from "lodash";
import {planTypes} from "@/common/constants";
import base from '@/views/config/addon-cards/templates/base.vue';
import { isZoomMeetingAsAddonCard } from '@/plans/ZOOM_MEETING/common/utils';
import { planTypesForMeeting } from '@/views/config/addon-cards/index.vue';

export default {
  name: 'LargeMeetingAddon',
  mixins: [base, planCommon],
  for: ()=> {
      const shouldHide = isZoomMeetingAsAddonCard();
      if(shouldHide) return [];
      return planTypesForMeeting();
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    lowestPlan() {
      const list = orderBy(filter(this.planMapFlat, (p) => p.type === planTypes.LARGE_MEETING && !p.isOneMonth), ['participants', 'amount'], 'asc')
      return get(list, [0], {});
    },
  }
};
</script>
